// ANETT HORVATH — Brand Assets Module
// Dynamic brand asset loading by key. NO hardcoded image paths.

export interface BrandAsset {
  id: string;
  asset_key: string;
  media_url: string;
  description: string;
  created_at: string;
}

const BRAND_KEY = 'ah_brand_assets';

function loadAssets(): BrandAsset[] {
  try { const r = localStorage.getItem(BRAND_KEY); return r ? JSON.parse(r) : seedAssets(); } catch { return seedAssets(); }
}
function saveAssets(a: BrandAsset[]) { localStorage.setItem(BRAND_KEY, JSON.stringify(a)); }

function seedAssets(): BrandAsset[] {
  const ts = new Date().toISOString();
  const items: BrandAsset[] = [
    { id: crypto.randomUUID(), asset_key: 'logo_primary', media_url: '/assets/ah-monogram.png', description: 'AH Monogram — Primary logo', created_at: ts },
    { id: crypto.randomUUID(), asset_key: 'logo_symbol', media_url: '/assets/house-symbol.png', description: 'House Symbol', created_at: ts },
    { id: crypto.randomUUID(), asset_key: 'perfume_editorial', media_url: '/assets/brand-editorial-spray.png', description: 'Editorial — Perfume Spray', created_at: ts },
    { id: crypto.randomUUID(), asset_key: 'aethera_moodboard', media_url: '/assets/brand-aethera-moodboard.png', description: 'AETHERA — Brand Moodboard', created_at: ts },
    { id: crypto.randomUUID(), asset_key: 'aethera_packaging', media_url: '/assets/brand-aethera-packaging.png', description: 'AETHERA — Extrait de Parfum Packaging', created_at: ts },
    { id: crypto.randomUUID(), asset_key: 'moonoflife_product', media_url: '/assets/brand-moonoflife-product.png', description: 'Moon of Life — Product Line', created_at: ts },
  ];
  saveAssets(items);
  return items;
}

export function getAllBrandAssets(): BrandAsset[] { return loadAssets(); }

export function getBrandAsset(key: string): string {
  const assets = loadAssets();
  const a = assets.find(x => x.asset_key === key);
  return a?.media_url || '';
}

export function upsertBrandAsset(id: string | null, key: string, url: string, description: string): BrandAsset {
  const assets = loadAssets();
  const ts = new Date().toISOString();
  if (id) {
    const idx = assets.findIndex(a => a.id === id);
    if (idx >= 0) { assets[idx] = { ...assets[idx], asset_key: key, media_url: url, description, created_at: assets[idx].created_at }; saveAssets(assets); return assets[idx]; }
  }
  const item: BrandAsset = { id: crypto.randomUUID(), asset_key: key, media_url: url, description, created_at: ts };
  assets.push(item);
  saveAssets(assets);
  return item;
}

export function deleteBrandAsset(id: string) {
  saveAssets(loadAssets().filter(a => a.id !== id));
}
